
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class Login extends Vue {
  async oktaLogin() {
    await this.$auth.clearDPoPStorage(true);
    await this.$auth.signInWithRedirect();
  } 
}
